
export default {
  head() {
    return {
      title:
        "Agence Google Ads | SEA à Villeneuve-d'Ascq dès 290€/mois - ALEO AGENCY",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "ALEO, agence Google Ads à Villeneuve-d'Ascq certifiée Google Partner, soutient les entreprises villeneuvoises pour renforcer leur présence en ligne et capter de nouveaux clients.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content:
            "Agence Google Ads à Villeneuve-d'Ascq dès 290€/mois - ALEO AGENCY",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "ALEO, agence Google Ads à Villeneuve-d'Ascq certifiée Google Partner, soutient les entreprises villeneuvoises pour renforcer leur présence en ligne et capter de nouveaux clients.",
        },
      ],
    };
  },
};
